<template>
  <CommonPanel title="促销工具">
    <div class='promotion-list'>
      <div class='promotion-item' v-for="(item, index) in list" :key="index">
        <a class='promotion-item-inner' :href="`${item.icon.link||''}`" @click="changeLink(item.icon, item.subIcon, $event)">
          <img :src="$viewImage(item.icon.icon)">
          <div class='promotion-item-info'>
            <h3>{{item.icon.title}}</h3>
            <p>{{item.icon.desc}}</p>
            <ul v-if="item.subIcon && item.subIcon.length > 0">
              <li v-for="(subItem, idx) in item.subIcon" :key="idx">
                <a :href='subItem.link' @click="changeMenu(subItem, $event)">{{subItem.title}}</a>
              </li>
            </ul>
          </div>
        </a>
      </div>
    </div>
  </CommonPanel>
</template>
<script>
import CommonPanel from "@/components/common-panel/index";
import { tracker } from '@/utils/utils'

export default {
  name: 'promotion',
  data() {
    return {
      list: [],
      key: 'promotion'
    }
  },
  async created() {
    tracker(169, 121012278, 10000, '', {name: '商家工作台营销中心促销管理页面'})
    const json = await this.$store.dispatch('template/getCMSConfig', {buzzType: 'pop', key: this.key})
    this.list = json.list || []
  },
  methods: {
    changeMenu(subItem, e) {
      tracker(169, 121012278, 20000, 200001, {name: subItem.title})
      this.$emit('menuChange', subItem)
      e.preventDefault()
      return false
    },
    changeLink(item, subs, e) {
      if (Array.isArray(subs) && subs.length > 0) {
        e.preventDefault()
        return false;
      }
      if (item.link) {
        tracker(169, 121012278, 20000, 200001, {name: item.title})
        this.$emit('menuChange', { link: item.link })
      }
      e.preventDefault()
      return false
    }
  },
  components: {
    CommonPanel
  }
}
</script>
<style lang="scss" scoped>
.promotion-list{
  width: 100%;
  padding-top: 40px;

  .promotion-item{
    width: 50%;
    display: inline-block;

    .promotion-item-inner{
      display: flex;
      padding: 20px;
      margin-right: 80px;
      margin-bottom: 40px;
      border: 1px solid transparent;

      &:hover{
        background: #FFFFFF;
        border: 1px solid #F1F3F5;
        box-shadow: 0 0 20px 0 rgba(0,0,0,0.05);
        border-radius: 8px;
        @include pointer();
      }
    }

    img{
      width: 100px;
      height: 100px;
      border-radius: 4px;
    }

    .promotion-item-info{
      flex:1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:20px;

      h3{
        font-size: 16px;
        color: $title-color-333;
        font-weight: 700;
        margin-bottom: 9px;
      }

      p{
        font-size: 14px;
        color:$text-secondary;
      }

      ul {
        display: flex;

        li{
          padding-right: 20px;
        }
      }
    }
  }
}
</style>
